import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

// Create a mock client if credentials are not provided
const isConfigured = supabaseUrl !== 'https://placeholder.supabase.co' && supabaseAnonKey !== 'placeholder-key';

export const supabase = isConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const isSupabaseConfigured = isConfigured;

// Helper functions for common operations
export const supabaseHelpers = {
  // Auth
  async signUp(email, password) {
    return await supabase.auth.signUp({ email, password });
  },
  
  async signIn(email, password) {
    return await supabase.auth.signInWithPassword({ email, password });
  },
  
  async signOut() {
    return await supabase.auth.signOut();
  },
  
  async getUser() {
    return await supabase.auth.getUser();
  },
  
  // Database operations
  async getData(table, filters = {}) {
    let query = supabase.from(table).select('*');
    
    Object.keys(filters).forEach(key => {
      query = query.eq(key, filters[key]);
    });
    
    return await query;
  },
  
  async insertData(table, data) {
    return await supabase.from(table).insert(data);
  },
  
  async updateData(table, id, data) {
    return await supabase.from(table).update(data).eq('id', id);
  },
  
  async deleteData(table, id) {
    return await supabase.from(table).delete().eq('id', id);
  }
};

export default supabase;